module.exports = __webpack_public_path__ + "static/media/HCMM527.34806498.jpg";